import { useLang } from 'hooks/lang';

import { Button, Column, Row } from 'components/Blocks';
import { GoBackButton } from 'components/Buttons';
import { TeamForm } from '../components';

import { UsersIcon } from 'components/Icons';

import { actions } from 'entities';
import { useDirectNavigation } from 'routes';

const defaultTeam = {
  name: '',

  reprice: null,
  outsourcing: null,
  taskManagement: null,
  addTaskSubOwner: null,

  hasServices: false,
  salesArea: false,
  canAssumeTasksFromOtherAreas: false,
  canAssumeProject: false,
  canRequestTaskReasignement: false,
  canSetDeadlines: false,
  canChangePrices: false,
  isProjectOwner: false,
  canCreateProject: false,
  canApproveDiscount: false,
  canEnableProjectToStart: false,
  canApproveCountryAddition: false,
  clientsPageAccess: false,
};

function CreateTeam() {
  const { t } = useLang();

  const goToTeams = useDirectNavigation('teams');

  const teamCreation = actions.teams.createTeam.use({
    onSuccess: goToTeams,
  });

  return (
    <Column gap="6">
      <Row>
        <GoBackButton className="mt-0.5" />

        <h5 className="flex items-center gap-2">
          <UsersIcon size={32} />

          {t('create-team')}
        </h5>
      </Row>

      <TeamForm data={defaultTeam} onSubmit={teamCreation.execute} disabled={teamCreation.loading}>
        <Button
          className="mx-auto flex min-w-[min(80%,880px)]"
          type="submit"
          loading={teamCreation.loading}
        >
          {t('create-team')}
        </Button>
      </TeamForm>
    </Column>
  );
}

export default CreateTeam;
